<template>
    <section class="globalbox">
        <div class="music">
            <audio ref="media"  class="audio" loop=""    width="1" height="1" preload=none :src="ossurl"></audio> 
  <!--           <div class="control" :class="(isPaly==true?'playing':'pause')">
                <div class="control-after" ></div>
            </div> -->
        </div>
    </section>
</template>
<script>
import store from '@/store'
export default {
  name: 'musicPlay',
  props: {
   ossurl: {
        type: String,
        default: ''
    }
  },
  data () {
    return {
       isPaly:false,
    }
  },
  methods: { 
    run(){
        let self=this;
        this.$nextTick(() => {
            // 开始加载数据时触发。
            self.Audio.onloadstart = () => {
                // console.log("loadstart-客户端开始请求数据。")
            }
            self.Audio.onwaiting = () => {
              // console.log("waiting-等待数据，并非错误")
             }
            // 文件下载完毕，如果不用等到全部下载完毕，可以用canplay事件
            self.Audio.oncanplaythrough = () => {
                // console.log("canplaythrough-可以播放，歌曲全部加载完毕,文件下载完毕，如果不用等到全部下载完毕，可以用canplay事件")
            };
             // 当播放器能够开始播放视频时触发。
            self.Audio.oncanplay = () => {
                // console.log("canplay-可以播放，但中途可能因为加载而暂停。",self.playInfo.currentTime)
            };
            // 频的时长数据发生变化时触发。
            self.Audio.ondurationchange = () => {
                // console.log("durationchange-频的时长数据发生变化时触发。")
            };
            // 已加载视频的 metadata。
            self.Audio.onloadedmetadata = () => {
               //  console.log("loadedmetadata-已加载视频的 metadata。")
            };
           // 当前帧的数据已加载，但没有足够的数据来播放视频下一帧时，触发该事件。
           self.Audio.onloadeddata = () => {
               // console.log("loadeddata-当前帧的数据已加载，但没有足够的数据来播放视频下一帧时，触发该事件。")
            };
             // 视频播放出现错误时触发。
            self.Audio.onerror = () => {
                // console.log("error-请求数据时遇到错误。")
            };
            // 在获取到媒体数据时触发。
            self.Audio.onseeking = () => {
                //console.log("seeking-寻找中")
            };
            // 在获取到媒体数据时触发。
            self.Audio.onseeked = () => {
                // console.log("seeked-寻找完毕")
            };
            // 在获取到媒体数据时触发。
            self.Audio.onprogress = () => {
                // console.log("progress-客户端正在请求数据。")
            };
            //当获取不到数据时产生该事件。
            self.Audio.onsuspend = () => {
               // console.log("suspend -延迟下载。")
            };
            //当试图获取媒体数据，但数据还不可用时产生该事件
            self.Audio.onstalled = () => {
                //console.log("stalled  -网速失速。")
            };
            //当音视频加载被异常终止时产生该事件。
            self.Audio.onabort = () => {
                //console.log("abort  -当音视频加载被异常终止时产生该事件。")
            };
            self.mediaPlay();
            /** 当前播放时间发生改变的时候 **/
            self.Audio.ontimeupdate = function(audioObj){
                if(self.isPaly==false||!self.Audio.duration)return
                store.commit('setIsPaly',"self.isPaly");
                //self.$EventBus.$emit("playOntimeupdate",{player:{isPaly:self.isPaly}});//通知监听页面
            }
       
            /** 播放完毕后-执行最新播放模式 **/
            //self.Audio.addEventListener('ended', self.PlayEnded, false);
        })
    },
    mediaPlay:function(){
      let self=this;
      this.$nextTick(() => {
          let playPromise = this.Audio.play();
          if (playPromise !== undefined) {
              playPromise.then(() => {
                  self.isPaly=true;
                  store.commit('setIsPaly',"self.isPaly");
                  //self.$EventBus.$emit("playOfState",{player:{isPaly:self.isPaly}});
              }).catch((e) => {
                  console.log("播放出错",e)
              })
          }
      })
    }
  },
  mounted () {
    let self=this;
    this.$nextTick(() => {
        self.Audio=this.$refs.media;
        //监听playEvent事件
        self.$EventBus.$on("playEvent",obj=>{
            let model=obj.model;
            //监听播放按钮变化
            if(model.playing===true){
                self.mediaPlay()
            }else{
              self.Audio.pause();
              self.isPaly=false;
              //由“外部页面触发”暂停的时候最后一次广播通知
              store.commit('setIsPaly',self.isPaly);
              //self.$EventBus.$emit("playOfState",{player:{isPaly:self.isPaly}});
            }
        })
    })
  }
}
</script>

<style scoped>

/* .music { width: 4.5rem; height: 4.5rem; position: fixed; right: .5rem; top: .5rem; z-index: 100; }
.music .control { position: relative; width: 4.5rem; height: 4.5rem;}
.music .control.playing{ background: url('../../assets/img/music_01.gif') transparent no-repeat center center; background-size: contain; }
.music .control .control-after { width: 2.5rem; height: 2.5rem; position: absolute; left:0; right:0; top:0; bottom:0;margin:auto;  background: url('../../assets/img/music_off.png') transparent no-repeat center center; background-size: 100% 100%; -webkit-animation: rotate2d 1.2s linear infinite; animation: rotate2d 1.2s linear infinite; z-index: -1; }
.music.stopped .control { background: 0 0; }
.music.stopped .control .control-after { -webkit-animation: none; animation: none; }
.music .control.pause .control-after { animation-play-state: paused; }

@-webkit-keyframes rotate2d {
from { -webkit-transform: rotate(0deg); transform: rotate(0deg); }
to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
}

@keyframes rotate2d {
from { -webkit-transform: rotate(0deg); transform: rotate(0deg); }
to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
} */
</style>


// WEBPACK FOOTER //
// src/components/musicPlay/musicPlay.vue